module.exports = __webpack_public_path__ + "static/media/radionacional.d666d85a.svg";